export function capitalizeFormMessage(message: string): string {
  return message.charAt(0).toUpperCase() + message.slice(1)
}
